import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import _ from 'lodash';

import './projectsList.scss';

import projectsStore from 'storeState/projects';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import ATable from "views/aTable/ATable";
import Button from "views/button/Button";
import Loading from "views/loading/Loading";

import {formatDateTime} from 'service/LocaleService';
import URLService from "../../../service/URLService";

export class ProjectsList extends Component {

  static contextTypes = {
    intl: PropTypes.object
  }

  componentDidMount() {
    this.tenant_id = this.props.tenant_id;
    this.props.actions.projectsListRequest({tenant_id: this.props.tenant_id});
  }

  componentWillReceiveProps = (nextProps) => {
    if(this.tenant_id != nextProps.tenant_id) {
      this.tenant_id = nextProps.tenant_id;
      //console.log("projectsListRequest in ProjectsList Component")
      this.props.actions.projectsListRequest({tenant_id: nextProps.tenant_id});
    }
  }

  onProjectClick = (project_id) => {
    if(this.props.onProjectSelect) {
      this.props.onProjectSelect(project_id);
    }
  }

  render() {
    return (
      <div className={`projects-list`}>
        <Loading finished={this.props.projects!=null} render={(()=>
          <ATable>
            <tbody>
            <tr>
              <th><FormattedMessage id="projectsList.name" defaultMessage="Name" /></th>
              <th><FormattedMessage id="projectsList.created_at" defaultMessage="Created at" /></th>
            </tr>
            <For each="project" of={this.props.projects}>
              <tr className={`clickable ${project.id === URLService.getQueryParameterAsString("project_id") ? 'selected': ''}`} onClick={() => this.onProjectClick(project.id)}>
                <td>{project.name}</td>
                <td>{formatDateTime(project.created_at)}</td>
              </tr>
            </For>
            <If condition={_.size(this.props.projects) === 0}>
              <tr>
                <td colSpan={2}><FormattedMessage id="projectsList.empty.message" defaultMessage="No Projects" /></td>
              </tr>
            </If>
            </tbody>
          </ATable>
        ).bind(this)} />
      </div>
    );
  }
}


export default connect((state, props) => {
  return {
    projects: projectsStore.selectors.projectsList(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, projectsStore.actions), dispatch)
  }
})(ProjectsList)



// WEBPACK FOOTER //
// ./src/components/views/projectsList/ProjectsList.js